// export const BASE_URL = "https://soni.loyalstring.co.in"
export const BASE_URL = "https://rrgold.loyalstring.co.in"
// Customer List All (GET)
export const a1 =
  // `https://sunshineteam.in/loyalstring/api_ls_customerall_data.php`;
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/CustomerDetails/GetAllCustomer`;
  `${BASE_URL}/api/CustomerDetails/GetAllCustomer`;

//   Customer List As per Customer Login Id (POST)
export const a2 =
  // `https://sunshineteam.in/loyalstring/api_ls_customerasperloginid_data.php`;
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/CustomerDetails/CustomerByLoginId`;
  `${BASE_URL}/api/CustomerDetails/CustomerByLoginId`;
//   Customer Details as per Customer id (POST)

export const a3 =
  // `https://sunshineteam.in/loyalstring/api_ls_customerasperuserid_data.php`;
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/CustomerDetails/GetCustomerById`;
  `${BASE_URL}/api/CustomerDetails/GetCustomerById`;

//   Add Customer (POST)
export const a4 =
  // `https://sunshineteam.in/loyalstring/api_ls_customer_insert.php`;
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/CustomerDetails/AddCustomer`;
  `${BASE_URL}/api/CustomerDetails/AddCustomer`;

//   Update Customer with AnyField except Customer_id and Data (POST)
export const a5 =
  // `https://sunshineteam.in/loyalstring/api_ls_customer_update.php`;
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/CustomerDetails/UpdateCustomer`;
`${BASE_URL}/api/CustomerDetails/UpdateCustomer`;
//   Add Staff (POST)
export const a6 =
  // `https://sunshineteam.in/loyalstring/api_ls_staff_insert.php`;
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/Staff/AddStaff`;
  `${BASE_URL}/api/Staff/AddStaff`;
//   Add Category (POST)
export const a7 =
  // `https://sunshineteam.in/loyalstring/api_ls_category_insert.php  `;
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/ProductMaster/InsertCategory`;
  `${BASE_URL}/api/ProductMaster/InsertCategory`;
//   Add Product (POST)
export const a8 =
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/ProductMaster/InsertProduct`;
  // `https://sunshineteam.in/loyalstring/api_ls_product_insert.php`;
  `${BASE_URL}/api/ProductMaster/InsertProduct`;
// `${BASE_URL}/api/ProductMaster/InsertBulkProduct`;

//   Add Wishlist (POST)
export const a9 =
  `https://sunshineteam.in/loyalstring/api_ls_wishlist_insert.php`;

//   Add Order (POST)
export const a10 =
  // `https://sunshineteam.in/loyalstring/api_ls_order_insert.php`;
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/Orders/InsertOrders`;
  `${BASE_URL}/api/Orders/InsertOrders`;

export const a11 =
  `https://sunshineteam.in/loyalstring/api_ls_rating_insert.php`;

// Add Rating (POST)

export const a12 =
  // `https://sunshineteam.in/loyalstring/api_ls_rates_insert.php`;
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/Orders/InsertRates`;
  `${BASE_URL}/api/Orders/InsertRates`;
// Add Rates to Category (POST)

export const a13 =
  // `https://sunshineteam.in/loyalstring/api_ls_ratestoday_data.php`;
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/Orders/ratestodaybycategory`;
  `${BASE_URL}/api/Orders/ratestodaybycategory`;

// Get Todays Rate as per Category (POST)
export const a14 =
  `https://sunshineteam.in/loyalstring/api_ls_ratesalldays_data.php`;
// Get All Rates as per Category (POST)

export const a15 = `https://sunshineteam.in/loyalstring/api_ls_rating_data.php`;
// Get Rating as per Product id (POST)

export const a16 =
  // `https://sunshineteam.in/loyalstring/api_ls_productall_data.php`;
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/ProductMaster/GetfetchAllProduct`;
  // `${BASE_URL}/api/ProductMaster/GetfetchAllProduct`;
  `${BASE_URL}/api/ProductMaster/GetuniqiueAllProduct`;
// Get All Product Information (GET)

export const a17 =
  // `https://sunshineteam.in/loyalstring/api_ls_productbyproductid_data.php`;
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/ProductMaster/fetchProductById`;
  `${BASE_URL}/api/ProductMaster/fetchProductById`;
// Get Product Inforation as per Product Id (POST)

export const a18 =
  // `https://sunshineteam.in/loyalstring/api_ls_categoryall_data.php`;
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/ProductMaster/fetchAllCategory`;
  `${BASE_URL}/api/ProductMaster/GetAllCategory`;
// Get All Categories (GET)

export const a19 =
  // `https://sunshineteam.in/loyalstring/api_ls_ratestodayallcategories_data.php`;
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/Orders/fetchTodayRates`;
  `${BASE_URL}/api/Orders/fetchTodayRates`;
// Get All Rates of today of all categories (GET)

export const a20 =
  // `https://sunshineteam.in/loyalstring/api_ls_producttypeall_data.php`;
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/ProductMaster/fetchAllProductType`;
  `${BASE_URL}/api/ProductMaster/GetAllProductMaster`;
// Get All ProductTypes (GET)

export const a21 =
  // `https://sunshineteam.in/loyalstring/api_ls_producttype_insert.php`;
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/ProductMaster/InsertProductType`;
  `${BASE_URL}/api/ProductMaster/InsertProductType`;
// Insert ProductType (POST)

export const a22 =
  // `https://sunshineteam.in/loyalstring/api_ls_purityall_data.php`;
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/ProductMaster/fetchAllPurity`;
  `${BASE_URL}/api/ProductMaster/fetchAllPurity`;
// Get All Purity data (GET)

export const a23 =
  // `https://sunshineteam.in/loyalstring/api_ls_purity_insert.php`;
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/ProductMaster/InsertPurity`;
  `${BASE_URL}/api/ProductMaster/InsertPurity`;
// Insert Purity data (POST)

export const a24 =
  // `https://sunshineteam.in/loyalstring/api_ls_product_update.php`;
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/ProductMaster/UpdateProduct`;
  `${BASE_URL}/api/ProductMaster/UpdateProduct`;
// Update Product data (POST)

export const a25 =
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/CustomerDetails/UpdatePassword`;
  `${BASE_URL}/api/CustomerDetails/UpdatePassword`;
// Update Password

export const a26 =
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/ProductMaster/UpdateImage`;
  `${BASE_URL}/api/ProductMaster/UpdateImage`;
// Update Images

export const a27 =
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/ProductMaster/AddPartyMaster`;
  `${BASE_URL}/api/ProductMaster/AddPartyMaster`;
// Add Supplier Details

export const a28 =
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/ProductMaster/GetAllPartyMaster`;
  `${BASE_URL}/api/ProductMaster/GetAllPartyMaster`;
// Get Supplier Details

export const a29 =
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/ProductMaster/AddBoxMaster`;
  `${BASE_URL}/api/ProductMaster/AddBoxMaster`;
// Add Box Details

export const a30 =
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/ProductMaster/GetAllBoxMaster`;
  `${BASE_URL}/api/ProductMaster/GetAllBoxMaster`;
// Get Box Details

export const a31 =
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/ProductMaster/BulkUpdateProduct`;
  `${BASE_URL}/api/ProductMaster/BulkUpdateProduct`;
// `${BASE_URL}/api/ProductMaster/BulkEditProduct`;
// Update Bulk Products

export const a32 =
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/ProductMaster/AddCollection`;
  `${BASE_URL}/api/ProductMaster/AddCollection`;
// Insert Collection

export const a33 =
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/ProductMaster/GetAllCollection`;
  `${BASE_URL}/api/ProductMaster/GetAllCollection`;
// Get Collection

export const a34 =
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/ProductMaster/UpdateCollection`;
  `${BASE_URL}/api/ProductMaster/UpdateCollection`;
// Update Collection

export const a35 =
  `${BASE_URL}/api/ProductMaster/UpdateCategory`;
// Update Category

export const a36 =
  `${BASE_URL}/api/ProductMaster/UpdateProductType`;
// Update ProductType

export const a37 =
  `${BASE_URL}/api/ProductMaster/UpdatePurity`;
// Update ProductType

export const a38 =
  `${BASE_URL}/api/Orders/fetchAllOrders`;
// fetch all order

export const a39 = `${BASE_URL}/api/Orders/UpdateOrders`;
// Update orders

export const a40 =
  // `https://sunshineteam.in/loyalstring/api_ls_customer_update.php`;
  // `https://jewellerywebapplication20230518130808.azurewebsites.net/api/CustomerDetails/UpdateCustomer`;
  `${BASE_URL}/api/CustomerDetails/UpdateCustomers`;
// Update Customer all fields

export const a41 =
  `${BASE_URL}/api/ProductMaster/GetfetchAllProduct`;
// Get All Products

export const a42 =
  `${BASE_URL}/api/CustomerDetails/GetOtp`;
// Get All Products

export const a43 =
  `${BASE_URL}/api/ProductMaster/GetAllRFID`;
// Get All Barcode and Tid

export const a44 = `${BASE_URL}/api/device/GetAllProduct`;
// Get All Data from external

export const a45 = `${BASE_URL}/api/Orders/DownloadPDF`;
// Download pdf with Img

export const a46 = `${BASE_URL}/api/Orders/PrintPDF`;
//  Download pdf without Img

export const a47 =
  `${BASE_URL}/api/ProductMaster/deleteProduct`;
// Delete Product with itemcode

export const a48 = `${BASE_URL}/api/Orders/CreateOrder`;
// Create Order Multiple

export const a49 =
  `${BASE_URL}/api/Orders/CreateOrderItem`;
// Create Order Items Multiple

export const a50 =
  `${BASE_URL}/api/Orders/AllOrderItemsByOrderId`;
// Get Order Items By Order id

export const a51 =
  `${BASE_URL}/api/Orders/DownloadInvoice`;
// Download Invoice

export const a52 =
  // `${BASE_URL}/api/Orders/AllOrderItemsByOrderId`;
  `${BASE_URL}/api/orders/Getfetchordersbyid`;
// Get All Order Items

export const a53 =
  `${BASE_URL}/api/Orders/CreateURDPurchase`;
// Add Purchase Items

export const a54 =
  `${BASE_URL}/api/Orders/GetAllURDPurchase`;
// Get All Purchase Items

export const a55 =
  `${BASE_URL}/api/ProductMaster/InsertUnlabledProducts`;
// Add Unlabelled Items

export const a56 =
  `${BASE_URL}/api/ProductMaster/GetAllUnlabelledStock`;
// Get All Unlabelled Items

export const a57 =
  `${BASE_URL}/api/ProductMaster/BulkUpdateUnLabeledProduct`;
// Update Unlabelled Items

export const a58 = `${BASE_URL}/api/Staff/AddSalesTeam`;
// Add New Employees

export const a59 = `${BASE_URL}/api/Staff/GetAllSaleTeam`;
// Get All Employee

export const a60 =
  `${BASE_URL}/api/Staff/UpdateSalesTeam`;
// Edit Employee

export const a61 =
  `${BASE_URL}/api/ProductMaster/GetActiveAllUnLabeledProducts`;
// Get Active Unlabel Products

export const a62 = `${BASE_URL}/api/device/Login`;
// Admin Panel Token Login

export const a63 =
  `${BASE_URL}/api/Orders/CreateCreditNote`;
// Apply Credit Note

export const a64 =
  `${BASE_URL}/api/ProductMaster/UpdatePartyMaster`;
// Update Supplier

export const a65 =
  `${BASE_URL}/api/RDPurchase/CreateRDPurchase`;
// Add Purchase Main Box

export const a66 =
  `${BASE_URL}/api/RDPurchase/CreateRDPurchaseItem`;
// Add Purchase Items

export const a67 =
  `${BASE_URL}/api/RDPurchase/GetAllRDPurchase`;
// Get All Rd Purchase

export const a68 =
  `${BASE_URL}/api/StyleMaster/GetAllStones`;
// Get All Stones

export const a69 = `${BASE_URL}/api/StyleMaster/AddStone`;
// Add New Stone

export const a70 =
  `${BASE_URL}/api/StyleMaster/UpdateStone`;
// // Update Stone
//
export const a71 =
  `${BASE_URL}/api/StyleMaster/GetAllSkuList`;
// Get ALL Sku

export const a72 =
  `${BASE_URL}/api/StyleMaster/AddSKUMaster`;
// Add Sku

export const a73 =
  `${BASE_URL}/api/Orders/GetAllPaymentMode`;
// Get All Payments

export const a74 =
  `${BASE_URL}/api/Orders/CreatePaymentMode`;
// Add New Payment

export const a75 =
  `${BASE_URL}/api/RDPurchase/PartyLedgerBySupplierId`;
// Get PartyLedger By SupplierId

export const a76 = `${BASE_URL}/api/Orders/UpdateOrder`;
// Update Customer Order Main Box

export const a77 =
  `${BASE_URL}/api/RDPurchase/UpdateRDPurchase`;
// Update RD Purchase Main Box

export const a78 =
  `${BASE_URL}/api/RDPurchase/UpdateRDPurchaseBalance`;
// Update RD Purchase Main Box Balance

export const a79 =
  `${BASE_URL}/api/ProductMaster/UpdateBoxMaster`;
// Update Box Master

export const a80 =
  `${BASE_URL}/api/Orders/CreateDebitNote`;
// Create Debit Note

export const a81 =
  `${BASE_URL}/api/Orders/updateOrderItem`;
// Update Order Items

export const a82 =
  `${BASE_URL}/api/Orders/LabeledStockReport`;
// Get Labelled Stock Report

export const a83 =
  `${BASE_URL}/api/Orders/ExchangeOrderItem`;
// Return Order Items

export const a84 =
  `${BASE_URL}/api/Orders/GetAllCreditNote`;
// Get All Credit Note

export const a85 =
  `${BASE_URL}/api/Orders/GetAllDebitNote`;
// Get All Debit Note

export const a86 = `${BASE_URL}/api/Orders/UpdateOrder`;
// Update Order Main Box

export const a87 =
  `${BASE_URL}/api/Orders/GetAllOrderItems`;
// Get All Order Items

export const a88 =
  `${BASE_URL}/api/RDPurchase/GetAllRDPurchaseItem`;
// Get All RD Purchase Items

export const a89 =
  `${BASE_URL}/api/StyleMaster/UpdateSKUMaster`;
// Update Sku

export const a90 = `${BASE_URL}/api/Orders/UploadExcel`;
// Upload Excel

export const a91 =
  `${BASE_URL}/api/Orders/DeletePaymentMode`;
// Delete Payment

export const a92 =
  `${BASE_URL}/api/Orders/ReturnAdvancePayment`;
// Return Advance to customer

// GOLD STRING APIS BELOW
// GOLD STRING APIS BELOW
// GOLD STRING APIS BELOW

// export const a93 =
//   `${BASE_URL}/api/ClientOnboarding/AddClientOnboarding`;

export const a93 =
  `${BASE_URL}/api/ClientOnboarding/AddClientOnboarding`;
// Gold String Add New client

export const a94 =
  `${BASE_URL}/api/ClientOnboarding/ClientOnboardingLogin`;
// Gold String Client Login

export const a95 =
  `${BASE_URL}/api/ClientOnboarding/GetAllCompanyDetails`;
// Get ALL Company Details

export const a96 =
  `${BASE_URL}/api/ClientOnboarding/UpdateCompanyInfo`;
// Update Company Details

export const a97 =
  `${BASE_URL}/api/ClientOnboarding/AddCompanyDetails`;
// Add Company Details

export const a98 =
  `${BASE_URL}/api/ClientOnboarding/GetAllBranchMaster`;
// Get ALL Branch Details

export const a99 =
  `${BASE_URL}/api/ClientOnboarding/UpdateBranchMaster`;
// Update Branch Details

export const a100 =
  `${BASE_URL}/api/ClientOnboarding/AddBranchMaster`;
// Add Branch Details

export const a101 =
  `${BASE_URL}/api/ClientOnboarding/GetAllCounters`;
// Get ALL Counter Details

export const a102 =
  `${BASE_URL}/api/ClientOnboarding/UpdateCounter`;
// Update Counter Details

export const a103 =
  `${BASE_URL}/api/ClientOnboarding/AddCounter`;
// Add Counter Details

export const a104 =
  `${BASE_URL}/api/ClientOnboarding/GetAllDepartment`;
// Get ALL Department Details

export const a105 =
  `${BASE_URL}/api/ClientOnboarding/UpdateDepartment`;
// Update Department Details

export const a106 =
  `${BASE_URL}/api/ClientOnboarding/AddDepartment`;
// Add Department Details

export const a107 =
  `${BASE_URL}/api/ClientOnboarding/GetAllRoles`;
// Get ALL Roles Details

export const a108 =
  `${BASE_URL}/api/ClientOnboarding/UpdateRoles`;
// Update Roles Details

export const a109 =
  `${BASE_URL}/api/ClientOnboarding/AddRoles`;
// Add Roles Details

export const a110 =
  `${BASE_URL}/api/ClientOnboarding/GetAllEmployee`;
// Get ALL Employees Details

export const a111 =
  `${BASE_URL}/api/ClientOnboarding/UpdateEmployee`;
// Update Employees Details

export const a112 =
  `${BASE_URL}/api/ClientOnboarding/AddEmployee`;
// Add Employees Details

export const a113 =
  `${BASE_URL}/api/ClientOnboarding/GetAllBankMaster`;
// Get ALL Banks Details

export const a114 =
  `${BASE_URL}/api/ClientOnboarding/UpdateBankMaster`;
// Update Banks Details

export const a115 =
  `${BASE_URL}/api/ClientOnboarding/AddBankMaster`;
// Add Banks Details

// export const a116 =
//   `${BASE_URL}/api/ClientOnboarding/GetAllBankMaster`;
// // Get ALL devices Details

// export const a117 =
//   `${BASE_URL}/api/ClientOnboarding/UpdateBankMaster`;
// // Update devices Details

// export const a118 =
//   `${BASE_URL}/api/ClientOnboarding/AddBankMaster`;
// // Add devices Details

export const a119 =
  `${BASE_URL}/api/ClientOnboarding/GetAllTaxMaster`;
// Get ALL Tax Details

export const a120 =
  `${BASE_URL}/api/ClientOnboarding/UpdateTaxMaster`;
// Update Tax Details

export const a121 =
  `${BASE_URL}/api/ClientOnboarding/AddTaxMaster`;
// Add Tax Details

export const a122 =
  `${BASE_URL}/api/ClientOnboarding/GetAllRateConversion`;
// Get ALL Rate Conversion Details

export const a123 =
  `${BASE_URL}/api/ClientOnboarding/UpdateRateConversion`;
// Update Rate Conversion Details

export const a124 =
  `${BASE_URL}/api/ClientOnboarding/AddRateConversion`;
// Add Rate Conversion Details

export const a125 =
  `${BASE_URL}/api/ProductMaster/GetAllCategory`;
// Get ALL Category Details

export const a126 =
  `${BASE_URL}/api/ProductMaster/UpdateCategoryMaster`;
// Update Category Details

export const a127 =
  `${BASE_URL}/api/ProductMaster/AddCategoryMaster`;
// Add Category Details

export const a128 =
  `${BASE_URL}/api/ProductMaster/GetAllProductMaster`;
// Get ALL Product Details

export const a129 =
  `${BASE_URL}/api/ProductMaster/UpdateProductMaster`;
// Update Product Details

export const a130 =
  `${BASE_URL}/api/ProductMaster/AddProductMaster`;
// Add Product Details

export const a131 =
  `${BASE_URL}/api/ProductMaster/GetAllDesign`;
// Get ALL Design Details

export const a132 =
  `${BASE_URL}/api/ProductMaster/UpdateDesign`;
// Update Design Details

export const a133 =
  `${BASE_URL}/api/ProductMaster/AddDesign`;
// Add Design Details

export const a134 =
  `${BASE_URL}/api/ProductMaster/GetAllPurity`;
// Get ALL Purity Details

export const a135 =
  `${BASE_URL}/api/ProductMaster/UpdatePurityMaster`;
// Update Purity Details

export const a136 =
  `${BASE_URL}/api/ProductMaster/AddPurityMaster`;
// Add Purity Details

export const a137 =
  `${BASE_URL}/api/ProductMaster/GetAllBoxMaster`;
// Get ALL Box Details

export const a138 =
  `${BASE_URL}/api/ProductMaster/UpdateBoxMaster`;
// Update Box Details

export const a139 =
  `${BASE_URL}/api/ProductMaster/AddBoxMaster`;
// Add Box Details

export const a140 =
  `${BASE_URL}/api/ProductMaster/GetAllCollection`;
// Get ALL Collection Details

export const a141 =
  `${BASE_URL}/api/ProductMaster/UpdateCollection`;
// Update Collection Details

export const a142 =
  `${BASE_URL}/api/ProductMaster/AddCollection`;
// Add Collection Details

export const a143 =
  `${BASE_URL}/api/ProductMaster/GetAllOccassion`;
// Get ALL Occassion Details

export const a144 =
  `${BASE_URL}/api/ProductMaster/UpdateOccassion`;
// Update Occassion Details

export const a145 =
  `${BASE_URL}/api/ProductMaster/AddOccassion`;
// Add Occassion Details

export const a146 =
  `${BASE_URL}/api/ProductMaster/GetAllStoneMaster`;
// // Get ALL Stone Master

export const a147 =
  `${BASE_URL}/api/ProductMaster/UpdateStoneMaster`;
// `${BASE_URL}/api/ProductMaster/UpdateStoneMaster`;
// // Update Stone Master

export const a148 =
  `${BASE_URL}/api/ProductMaster/AddStoneMaster`;
// // Add Stone Master
export const a149 =
  `${BASE_URL}/api/ProductMaster/GetAllPartyDetails`;
// Get ALL Party Details

export const a150 =
  `${BASE_URL}/api/ProductMaster/UpdatePartyDetails`;
// Update Party Details

export const a151 =
  `${BASE_URL}/api/ProductMaster/AddPartyDetails`;
// Add Party Details

export const a152 =
  `${BASE_URL}/api/ProductMaster/GetAllStoneDetails`;
// Get All Stones Details

export const a153 =
  `${BASE_URL}/api/ProductMaster/GetAllDiamondMaster`;
// Get All Diamonds Master

export const a154 =
  `${BASE_URL}/api/Invoice/AddRdPurchase`;
// Add RD Purchase Main Box

export const a155 =
  `${BASE_URL}/api/Invoice/AddRdPurchaseItem`;
// Add RD Purchase Items

export const a156 =
  `${BASE_URL}/api/Invoice/AddPaymentMode`;
// Add Payment Mode

export const a157 =
  `${BASE_URL}/api/Invoice/AddPurchaseStoneDetails`;
// Add Purchase Stone Details

export const a158 =
  `${BASE_URL}/api/Invoice/AddPurchaseDiamondDetails`;
// Add Purchase Diamond Details

export const a159 =
  `${BASE_URL}/api/Invoice/GetAllRDPurchase`;
// GET All RD Purchase Main Box
export const a160 =
  `${BASE_URL}/api/Invoice/GetAllURDPurchase`;
// GET All URD_Purchase Main Box

export const a161 =
  `${BASE_URL}/api/Invoice/GetRDPurchaseById`;
// GET RD Purchase Main Box by ID

export const a162 =
  `${BASE_URL}/api/Invoice/GetAllRDPurchaseItem`;
// GET All RD Purchase Items

export const a163 =
  `${BASE_URL}/api/ProductMaster/GetAllSKU`;
// GET All SKU List

export const a164 =
  `${BASE_URL}/api/Invoice/GetRDPurchaseItemByPurchaseId`;
// GET All Purchase Items by id

export const a165 =
  `${BASE_URL}/api/Invoice/GetAllPaymentMode`;
// GET All Payments

export const a166 =
  `${BASE_URL}/api/Invoice/UpdateRDPurchase`;
// Update Rd Main Box

export const a167 =
  `${BASE_URL}/api/Invoice/UpdatePaymentMode`;
// Update Payments

export const a168 =
  `${BASE_URL}/api/ProductMaster/AddSKU`;
// Add Sku

export const a169 =
  `${BASE_URL}/api/ProductMaster/UpdateSKU`;
// Update Sku

export const a170 =
  `${BASE_URL}/api/Invoice/GetAllPurchaseLot`;
// Get All Purchase lot

export const a171 =
  `${BASE_URL}/api/Invoice/AddPurchaseLot`;
// Add Purchase lot

export const a172 =
  `${BASE_URL}/api/ClientOnboarding/VerifyEmailAddress`;
//Send Otp

export const a173 =
  `${BASE_URL}/api/ClientOnboarding/GetAllCustomer`;
//Fetch All Customers

export const a174 =
  `${BASE_URL}/api/Invoice/GetAllVendorTounch`;
//Fetch All Vendor Tounche

export const a175 =
  `${BASE_URL}/api/ProductMaster/GetAllRFID`;
//Fetch All RFID Data

export const a176 =
  `${BASE_URL}/api/ProductMaster/AddLabeledStock`;
//Add Labelled Stock

export const a177 =
  `${BASE_URL}/api/ProductMaster/UpdateLabeledStock`;
//Update Labelled Stock

export const a178 =
  `${BASE_URL}/api/ProductMaster/DeleteLabeledStock`;
//Delete Labelled Stock

export const a179 =
  `${BASE_URL}/api/Invoice/AddVendorTounch`;
//Add Vendor Tounche

export const a180 =
  `${BASE_URL}/api/Invoice/UpdateVendorTounch`;
//Update Vendor Tounche

export const a181 =
  `${BASE_URL}/api/ProductMaster/GetAllLabeledStock`;
export const an181 =
  `${BASE_URL}/api/ProductMaster/GetAllLabeledStockNew`;
//Get All Labelled Stock

export const a182 =
  `${BASE_URL}/api/ProductMaster/GetAllDiamondDetails`;
//Get All Diamond Master

export const a183 =
  `${BASE_URL}/api/ProductMaster/AddDiamondDetails`;
//Add Diamond Master

export const a184 =
  `${BASE_URL}/api/ProductMaster/UpdateDiamondDetails`;
//Update Diamond Master

export const a185 =
  `${BASE_URL}/api/ProductMaster/GetAllUnlabelledStock`;
//Get All Unlabelled Stock

export const a186 =
  `${BASE_URL}/api/ProductMaster/AddUnlabelledStock`;
//Add Unlabelled Stock

export const a187 =
  `${BASE_URL}/api/ProductMaster/UpdateUnlabelledStock`;
//Update Unlabelled Stock

export const a188 =
  `${BASE_URL}/api/Invoice/GetAllInvoice`;
//Get All Invoice

export const a189 =
  `${BASE_URL}/api/ClientOnboarding/AddCustomer`;
//Add Customer

export const a190 =
  `${BASE_URL}/api/ClientOnboarding/UpdateCustomer`;
//Update Customer

export const a191 =
  `${BASE_URL}/api/ProductMaster/GetDiamondSizeWeightRateTemplate`;
//Get All Diamond Size Weight Rate
export const getAllSizeWeightRate =
  `${BASE_URL}/api/ProductMaster/GetAllDiamondSizeWeightRate`;

export const a192 =
  `${BASE_URL}/api/ProductMaster/AddDiamondSizeWeightRate`;
//Add Diamond Size Weight Rate

export const a193 =
  `${BASE_URL}/api/ProductMaster/UpdateDiamondSizeWeightRate`;
//Update Diamond Size Weight Rate

export const a194 =
  `${BASE_URL}/api/ProductMaster/GetAllDiamondAttributes`;
//Get All Diamond Attributes

//Get All Diamond Attributes

export const a195 =
  `${BASE_URL}/api/ProductMaster/AddDiamondAttributes`;
//Add Diamond Attributes

export const a196 =
  `${BASE_URL}/api/ProductMaster/UpdateDiamondAttributes`;
//Update Diamond Attributes

//Update Diamond Attributes

export const a197 =
  `${BASE_URL}/api/ProductMaster/GetAllUnlabelledStock`;
//Get All Unlabelled Stock

export const a198 =
  `${BASE_URL}/api/ProductMaster/AddUnlabelledStock`;
//Add Unlabelled Stock

export const a199 =
  `${BASE_URL}/api/ProductMaster/UpdateUnlabelledStock`;
//Update Unlabelled Stock

export const a200 =
  `${BASE_URL}/api/ProductMaster/GetLabeledStockById`;
//Get Labelled Stock By Id

export const a201 = `${BASE_URL}/api/Invoice/AddInvoice`;
//Add Invoice

export const a202 =
  `${BASE_URL}/api/Invoice/GetInvoiceById`;
//Get Invoice By Id

export const a203 =
  `${BASE_URL}/api/ProductMaster/PaireCustomerVendorId`;
//Pair Customer VendorId

export const a204 =
  `${BASE_URL}/api/Invoice/GetAllCustomerTounch`;
//Get All Customer Tounche

export const a205 =
  `${BASE_URL}/api/Invoice/AddCustomerTounch`;
//Add Customer Tounche

export const a206 =
  `${BASE_URL}/api/Invoice/UpdateCustomerTounch`;
//Update Customer Tounche

export const a207 =
  `${BASE_URL}/api/ProductMaster/GetAllCustomerSlab`;
//Get All Customer Slab

export const a208 =
  `${BASE_URL}/api/ProductMaster/AddCustomerSlab`;
//Add Customer Slab

export const a209 =
  `${BASE_URL}/api/ProductMaster/UpdateCustomerSlab`;
//Update Customer Slab

export const a210 =
  `${BASE_URL}/api/ProductMaster/GetAllRateOfInterest`;
//Get All Rate Of Interest

export const a211 =
  `${BASE_URL}/api/ProductMaster/AddRateOfInterest`;
//Add Rate Of Interest

export const a212 =
  `${BASE_URL}/api/ProductMaster/UpdateRateOfInterest`;
//Update Rate Of Interest

export const a213 =
  `${BASE_URL}/api/ProductMaster/GetAllCreditPeriod`;
//Get All Credit Period

export const a214 =
  `${BASE_URL}/api/ProductMaster/AddCreditPeriod`;
//Add Credit Period

export const a215 =
  `${BASE_URL}/api/ProductMaster/UpdateCreditPeriod`;
//Update Credit Period

export const a216 =
  `${BASE_URL}/api/ProductMaster/GetStockReport`;

export const a217 =
  `${BASE_URL}/api/ProductMaster/InsertLabelledStock`;
// `${BASE_URL}/api/ProductMaster/InsertLabelledStock`;
//Add Bulk Stock New

export const a218 =
  `${BASE_URL}/api/Reports/StockReportByCategory`;
//Get Stock Report Default

export const a219 =
  `${BASE_URL}/api/Reports/StockReportByProduct`;
//Get Stock Report for Products

export const a220 =
  `${BASE_URL}/api/Reports/StockReportByDesign`;
//Get Stock Report for Design

export const a221 =
  `${BASE_URL}/api/Reports/SKUVendorwiseReport`;
//Get SKU Vendor wise Report

export const a222 =
  `${BASE_URL}/api/Reports/SKUStockReport`;
//Get SKU Vendor wise Report

export const a223 = `${BASE_URL}/api/Invoice/MakePayment`;
// Update RD Purchase Main Box Balance

export const a224 =
  `${BASE_URL}/api/ProductMaster/AddPacketMaster`;
// Add Packet Master

export const a225 =
  `${BASE_URL}/api/ProductMaster/UpdatePacketMaster`;
// Update Packet Master

export const a226 =
  `${BASE_URL}/api/ProductMaster/GetAllPacketMaster`;
// Get All Packet Master

export const a227 =
  `${BASE_URL}/api/RFIDdevice/GetAllRFIDdevice`;
// Get All RFID device

export const a228 =
  `${BASE_URL}/api/Invoice/GetAllCreditNote`;
// Get All Credit Note

export const a229 =
  `${BASE_URL}/api/Invoice/AddCreditNote`;
// Add Credit Note

export const a230 =
  `${BASE_URL}/api/Invoice/GetAllDebitNote`;
// Get All Debit Note

export const a231 =
  `${BASE_URL}/api/Invoice/AddDebitNote`;

// Add Debit Note

// export const s1 = `http://localhost:3000/demo/Images/`;
// export const s1 = `https://mkgharejewellers.com/demo/Images/`;
export const s1 = `${BASE_URL}/images`;
// export const s1 = `https://goldkarizma.com/demo/Images/`;

//For Local Images
// export const navigates = useNavigate();
// export const s2 = `http://localhost:3000/contactdetails`;

export const s2 = `https://mkgharejewellers.com/contactdetails`;
// export const s2 = `https://mgharejewellers.com/demo/contactdetails`;
// export const s2 = `https://goldkarizma.com/demo/contactdetails`;
// export const s3 = `https://product123.blob.core.windows.net/images`;

export const s3 =
  // `https://product123.blob.core.windows.net/images`;
  `https://jewellerywebapplications.blob.core.windows.net/images`;
// `${BASE_URL}/api/RDPurchase/GetAllRDPurchase`;

export const paymentApi = `http://localhost:5000`;
// export const paymentApi = `https://goldkarizma.com`;
// export const paymentApi = `https://goldkarizma.com/nodjs`;

// adminadddiamondsizeweightrate post api
export const postAdminadddiamondsizeweightrate = `${BASE_URL}/api/ProductMaster/SaveDiamondSizeWeightRateTemplate`;

//Get Stock Transfer Type
export const a232 =
  `${BASE_URL}/api/ProductMaster/GetStockTransferTypes`;

// Filter labeled stock
export const a233 =
  `${BASE_URL}/api/ProductMaster/GetAllLabeledStockByFilter`;

// Filter unlabeled stock
export const a234 =
  `${BASE_URL}/api/ProductMaster/GetAllUnlabelledStockByFilter`;

// add stock transfer
export const a235 =
  `${BASE_URL}/api/ProductMaster/AddStockTransfer`;

//get all stock transfers
export const a236 =
  `${BASE_URL}/api/ProductMaster/GetAllStockTransfers`;

//add Approve Stock Transfer
export const a237 =
  `${BASE_URL}/api/ProductMaster/ApproveStockTransfer`;
//add device
export const a238 =
  `${BASE_URL}/api/RFIDdevice/AddRFIDdevice`;

//Update device
export const a239 =
  `${BASE_URL}/api/RFIDdevice/UpdateRFIDdevice`;
//Update todays rates
export const a240 =
  `${BASE_URL}/api/ProductMaster/AddDailyRate`;

export const a749 =
  `${BASE_URL}/api/ProductMaster/UpdateDailyRates`;

export const a750 =
  `${BASE_URL}/api/ProductMaster/GetAllDailyRate`;
//filter packets
export const a241 =
  `${BASE_URL}/api/Reports/StockReportByPacket`;
//filter box
export const a242 =
  `${BASE_URL}/api/Reports/StockReportByBox`;

export const a243 =
  `${BASE_URL}/api/RoleManagement/GetAllUserPermissions`;

export const a244 =
  `${BASE_URL}/api/RoleManagement/AddAllUserPermissions`;

export const a245 =
  `${BASE_URL}/api/RoleManagement/UpdateEmployeeStatus`;
export const a246 =
  `${BASE_URL}/api/RoleManagement/GetAllEmployees`;

export const a247 =
  `${BASE_URL}/api/RoleManagement/GetAllNewRolesDetails`;
export const a248 =
  `${BASE_URL}/api/ProductMaster/GetAllStoneAttributes`;

//Jay Api
export const a699 =
  `${BASE_URL}/api/ProductMaster/GetAllStoneAttributes`;

export const a700 =
  `${BASE_URL}/api/ProductMaster/AddStoneAttributes`;
//Add Diamond Attributes

export const a701 =
  `${BASE_URL}/api/ProductMaster/UpdateStoneAttributes`;

//get batch label stock
export const g1 =
  `${BASE_URL}/api/ProductMaster/GetBatchedLabelledStock`;

//Jay Api for forms

//add customer
export const a704 =
  `${BASE_URL}/api/ClientOnboarding/AddCustomer`;

//update customer

export const a710 =
  `${BASE_URL}/api/ClientOnboarding/UpdateCustomer`;

//add vendor
export const a705 =
  `${BASE_URL}/api/ProductMaster/AddPartyDetails`;

//get all customers
export const a706 =
  `${BASE_URL}/api/ClientOnboarding/GetAllCustomer`;

//add employee

export const a707 =
  `${BASE_URL}/api/ClientOnboarding/AddEmployee`;

//update employee
export const a708 =
  `${BASE_URL}/api/ClientOnboarding/UpdateEmployee`;

//get emp
export const a709 =
  `${BASE_URL}/api/ClientOnboarding/GetAllEmployee`;

//add company
export const a711 =
  `${BASE_URL}/api/ClientOnboarding/AddCompanyDetails`;

//update company

export const a712 =
  `${BASE_URL}/api/ClientOnboarding/UpdateCompanyInfo`;

// get companies
export const a713 =
  `${BASE_URL}/api/ClientOnboarding/GetAllCompanyDetails`;

//add branch
export const a714 =
  `${BASE_URL}/api/ClientOnboarding/AddBranchMaster`;

//update branch
export const a715 =
  `${BASE_URL}/api/ClientOnboarding/UpdateBranchMaster`;

//get branch
export const a716 =
  `${BASE_URL}/api/ClientOnboarding/GetAllBranchMaster`;

//add counter
export const a717 =
  `${BASE_URL}/api/ClientOnboarding/AddCounter`;

//update counter
export const a718 =
  `${BASE_URL}/api/ClientOnboarding/UpdateCounter`;

//get counter

export const a719 =
  `${BASE_URL}/api/ClientOnboarding/GetAllCounters`;

//add tax
export const a720 =
  `${BASE_URL}/api/ClientOnboarding/AddTaxMaster`;

//update tax
export const a721 =
  `${BASE_URL}/api/ClientOnboarding/UpdateTaxMaster`;

//get tax list

export const a722 =
  `${BASE_URL}/api/ClientOnboarding/GetAllTaxMaster`;

//add category

export const a723 =
  `${BASE_URL}/api/ProductMaster/AddCategoryMaster`;

//update category
export const a724 =
  `${BASE_URL}/api/ProductMaster/UpdateCategoryMaster`;

//get category
export const a725 =
  `${BASE_URL}/api/ProductMaster/GetAllCategory`;

//get Stone
export const a726 =
  `${BASE_URL}/api/ProductMaster/GetAllStoneMaster`;

//update stone
export const a727 =
  `${BASE_URL}/api/ProductMaster/UpdateStoneMaster`;

//add stone
export const a728 =
  `${BASE_URL}/api/ProductMaster/AddStoneMaster`;

// rrgold
export const a729 = `${BASE_URL}/api/Invoice/AddInvoice`;
export const a730 =
  `${BASE_URL}/api/Invoice/GetInvoiceById`;
export const a731 =
  `${BASE_URL}/api/Invoice/UpdateInvoice`;
export const a732 =
  `${BASE_URL}/api/Invoice/GetAllVendorTounch`;
export const a733 =
  `${BASE_URL}/api/Reports/LotAuditReport`;

export const a734 =
  `${BASE_URL}/api/ProductMaster/GetAllStoneMaster`;

//add box
export const a737 =
  `${BASE_URL}/api/ProductMaster/AddBoxMaster`;

//update box
export const a738 =
  `${BASE_URL}/api/ProductMaster/UpdateBoxMaster`;

//get box

export const a739 =
  `${BASE_URL}/api/ProductMaster/GetAllBoxMaster`;

//add vendor
export const a741 =
  `${BASE_URL}/api/ProductMaster/AddPartyDetails`;

//update vendor

export const a742 =
  `${BASE_URL}/api/ProductMaster/UpdatePartyDetails`;

//get vendor
export const a743 =
  `${BASE_URL}/api/ProductMaster/GetAllPartyDetails`;

export const a735 =
  `${BASE_URL}/api/Invoice/AddVendorTounch`;
//Add Vendor Tounche

export const a736 =
  `${BASE_URL}/api/Invoice/GetVendorTounchById`;
export const a740 =
  `${BASE_URL}/api/Invoice/GetAllCustomerTounch`;
export const a744 =
  `${BASE_URL}/api/Invoice/AddCustomerTounch`;
export const a745 =
  `${BASE_URL}/api/Invoice/GetCustomerTounchById`;

export const a746 =
  `${BASE_URL}/api/Invoice/UpdateVendorTounch`;

export const a747 =
  `${BASE_URL}/api/Invoice/UpdateCustomerTounch`;
export const a748 =
  `${BASE_URL}/api/ProductMaster/GetAllSKUById`;

export const a751 = `${BASE_URL}/api/Reports/LotAuditReport`;

export const a752 =
  `${BASE_URL}/api/ProductMaster/GetAllLabeledStock`;

export const a753 =
  `${BASE_URL}/api/ProductMaster/GetAllStoneAttributes`;

export const a754 =
  `${BASE_URL}/api/Invoice/LastInvoiceNo`;
export const a755 =
  `${BASE_URL}/api/Invoice/GetAllInvoice`;
export const a756 =
  `${BASE_URL}/api/ProductMaster/InsertLabelledStock`;
export const a757 =
  `${BASE_URL}/api/ProductMaster/GetLabeledStockById`;
export const a758 =
  `${BASE_URL}/api/Reports/VendorOutStandingReport`;

export const j759 = `${BASE_URL}/api/Order/AddQuotation`;
export const j760 = `${BASE_URL}/api/Order/GetAllQuotation`;
export const j761 =`${BASE_URL}/api/Order/GetQuotationById`;
export const j762 =
  `${BASE_URL}/api/Order/LastQuotationNo`;
export const j763 =
  `${BASE_URL}/api/Invoice/UpdateQuotation`;
export const a759 =
  `${BASE_URL}/api/ProductMaster/GetAllLabeledStock`;
export const a760 =
  `${BASE_URL}/api/ProductMaster/UpdateLabeledStock`;

export const a761 =
  `${BASE_URL}/api/ProductMaster/GetAllLabeledStockCount`;
export const a762 =
  `${BASE_URL}/api/Invoice/GetRDPurchaseItemByPurchaseId`;
export const a763 =
  `${BASE_URL}/api/Invoice/GetRDPurchaseById`;
export const a764 =
  `${BASE_URL}/api/ProductMaster/GetUploadedImages`;
export const a765 =
  `${BASE_URL}/api/ProductMaster/UploadImagesByClientCode`;
export const a766 =
  `${BASE_URL}/api/ProductMaster/DeleteUploadedImage`;
export const a767 =
  `${BASE_URL}/api/Reports/GetAllCustomerTransaction`;
export const a768 = `${BASE_URL}/api/ProductMaster/GetLabelledStockByTIDNumbers`;
export const a769 = `${BASE_URL}/api/Reports/AddCustomerTransaction`;
export const a770 = `${BASE_URL}/api/Transaction/AddCustomerIssue`;
export const a771 =
`${BASE_URL}/api/ProductMaster/AddProductMaster`;

export const a772 =
`${BASE_URL}/api/ProductMaster/GetAllProductMaster`;

export const a773 = `${BASE_URL}/api/Order/AddCustomOrder`;

export const a774 = `${BASE_URL}/api/Order/GetAllOrders`;

export const a775 = `${BASE_URL}/api/order/GetOrderById`; 

export const a776 = `${BASE_URL}/api/order/update-order`;

export const a777 = `${BASE_URL}/api/Order/LastOrderNo`;
